<template>
  <!-- Not Used -->
  <div class="page-layout simple crmaccounttypeblock right-sidebar inner-sidebar">
    <div class="account-type-block">
      <div id="mail" style="">
        <div class="content-section crmaccounttypeblock-section" style="">
          <div class="center-section" style="background-color: #00448b;overflow-y: scroll;margin-bottom: 20px;">
            <div class="row">
              <div class="col-lg-12 mb-12">
                <h4 class="text-white headertextcrm">Welcome to DigiCRM</h4>
                <p class="text-white ptext">
                  DigiCRM builds customer relationships and
                  streamline processes which can increase sales,
                  improve customer service, and increase profitability.
                </p>
              </div>
            </div>
            <div class="preview-elements">
              <ul class="list-group account-group">
                <li class="list-group-item" v-on:click="createAccountSetup()" id="company_setup">
                  <div class="list-item-content text-secondary">Create Your Company Account</div>
                  <div class="avatar">
                    <img src="/static/images/man-with-company.svg" />
                  </div>
                </li>
                <li class="list-group-item" v-on:click="createCompanySetup()" id="personal_setup">
                  <div class="list-item-content text-secondary">Create Your Personal Account</div>
                  <div class="avatar">
                    <img src="/static/images/user.svg" />
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="fuse-sidebar crmaccounttype-sidebar sidebar left-positioned open locked-open" style="border-radius: 15px;overflow-y: scroll;">
            <div class="preview-elements details-block">
              <div class="crmaccounttypecard crmaccounttype-over-card mt-4 personal">
                <div class="crmaccounttypecard-body mb-10" style="padding: 55px 85px 0px;">
                  <img src="/static/images/crm-home-screen.svg" onmousedown="return false;" ondragstart="return false;" class="img-fluid" />
                </div>
                <div style="font-size: 18px;color: #00448b;font-weight: 600;padding: 25px 10px;margin: 0 auto;text-align: center;">
                  DigiCRM
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {},
  methods: {
    createAccountSetup() {
      this.$router.push({
        path: "/setup",
      });
    },
    createCompanySetup() {
      this.$router.push({
        path: "/accountsetup",
      });
    },
  },
  created() {
    if (this.$store.getters.loggedInUser) {
      this.$router.push("/");
    }
  },
};
</script>
<style>
.page-layout.simple.crmaccounttypeblock {
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  width: 100%;
  min-width: 100%;
}
.page-layout.simple.crmaccounttypeblock.right-sidebar.inner-sidebar {
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}
.account-type-block {
  position: relative;
  height: 100%;
  margin: 10px;
}
.content-section.crmaccounttypeblock-section {
  display: flex;
  min-height: 0;
  border-radius: 15px;
  background-color: #00448b;
  position: absolute;
  top: 0px;
  bottom: 0px;
  height: 100%;
  width: 100%;
}
.reduceTop {
  padding-top: 0px !important;
}
.fuse-sidebar.crmaccounttype-sidebar {
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  top: 0;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  width: 500px;
  min-width: 500px;
  max-width: 500px;
  z-index: 1000;
}
.fuse-sidebar.crmaccounttype-sidebar.left-positioned {
  right: 0;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
}
.page-layout.simple.crmaccounttypeblock.right-sidebar.inner-sidebar
  .content-section.crmaccounttypeblock-section
  .sidebar.locked-open {
  background: #fff;
  padding-left: 10px;
  padding-right: 10px;
  box-shadow: none;
  border: 2px solid #00448b;
}
.page-layout.simple.crmaccounttypeblock.right-sidebar.inner-sidebar
  .content-section.crmaccounttypeblock-section
  .sidebar {
  order: 2;
  overflow-y: visible;
  overflow-x: visible;
}
.fuse-sidebar.crmaccounttype-sidebar.locked-open {
  position: relative !important;
  -webkit-transform: translateX(0) !important;
  transform: translateX(0) !important;
}
.page-layout.simple.crmaccounttypeblock.right-sidebar.inner-sidebar
  .content-section.crmaccounttypeblock-section
  .center-section {
  order: 1;
  padding: 10px 20px;
  background-color: #00448b;
  border-radius: 15px 0px 0px 15px;
}
.page-layout.simple.crmaccounttypeblock.left-sidebar.inner-sidebar
  .content-section.crmaccounttypeblock-section
  .center-section,
.page-layout.simple.crmaccounttypeblock.right-sidebar.inner-sidebar
  .content-section.crmaccounttypeblock-section
  .center-section {
  flex: 1 1 auto;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.contactinfo {
  min-height: 8.8rem;
}
.contactinfo span.name {
  font-size: 18px;
  font-weight: 600;
}
.avatar-wrapper-contactinfo {
  position: relative;
  border: 1px solid #fff;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  line-height: 56px;
  min-width: 60px;
  text-align: center;
  margin: 0 auto;
}
.avatar-wrapper-contactinfo .avatar {
  width: 50px;
  height: 50px;
  line-height: 50px;
  min-width: 50px;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  font-size: 24px;
  font-weight: 500;
  text-align: center;
  color: #ffffff;
  background-color: #e0e3e6;
}
.contactinfo .last-message {
  max-width: 180px;
  margin-bottom: 0;
  font-weight: 500;
  color: #fff;
}
.contactinfo .last-message-time {
  white-space: nowrap;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
}
.contactinfo .unread-message-count {
  color: #fff;
  font-size: 15px;
  font-weight: 600;
}
.crmaccounttype-list {
  flex-flow: row wrap;
  box-sizing: border-box;
  display: flex;
  place-content: start;
  align-items: center;
  flex: 0 0 auto;
  padding: 15px 0;
  max-height: none !important;
}
.crmaccounttype-list-item {
  flex-direction: column;
  box-sizing: border-box;
  display: flex;
  place-content: flex-start;
  align-items: center;
  min-width: 165px;
  min-height: 150px;
  width: 165px;
  height: 150px;
  padding: 10px 0;
  margin: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
}
.crmaccounttype-list-item .crmaccounttype-wrapper {
  font-size: 100px !important;
  width: 100px !important;
  height: 100px !important;
  min-width: 100px !important;
  min-height: 100px !important;
  line-height: 70px !important;
  text-align: center;
}
.crmaccounttype-list-item .crmaccounttype-wrapper.selected {
  border: 1px solid #fff;
  border-radius: 27px;
}
.crmaccounttype-list-item img.crmaccounttype-images {
  font-size: 85px !important;
  width: 85px !important;
  height: 85px !important;
  min-width: 85px !important;
  min-height: 85px !important;
  line-height: 85px !important;
  display: inline-block;
}
.crmaccounttype-name {
  padding: 8px 5px 0;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  color: #fff;
}
.list-group .list-group-item > .avatar.avatarbank {
  -webkit-border-radius: 10px;
  border-radius: 10px;
}
.list-group .list-group-item > .avatar.avatarbank > img {
  max-width: 110px;
  max-height: 70px;
}
.terminate-buttons {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 15px;
}
.terminate-left,
.terminate-right {
  float: none !important;
}
.headertextcrm {
  font-size: 24px;
  font-weight: bold;
  line-height: 1.21;
  letter-spacing: 0.17px;
  margin-bottom: 24px;
  margin-top: 30px;
  color: #fff;
  margin-right: 15px;
  margin-left: 15px;
}
.ptext {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.22;
  letter-spacing: 0.12px;
  color: #ffffff;
  margin-bottom: 20px;
  margin-right: 15px;
  margin-left: 15px;
}
.list-group.account-group .list-group-item {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  border: none;
  padding: 24px 34px;
  min-height: 4.8rem;
  line-height: 1.6rem;
  text-decoration: none;
  margin-bottom: 30px;
  border-radius: 6px;
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(30px);
  box-shadow: 5px 5px 5px 0 rgba(0, 0, 0, 0.15);
  background-color: #ffffff;
  margin-left: 15px;
  margin-right: 45px;
  cursor: pointer;
}
.list-group.account-group .list-group-item > .list-item-content {
  font-size: 20px;
  font-weight: bold;
  line-height: 1.2;
  letter-spacing: 0.14px;
  text-align: left;
  color: #00448b;
}
.list-group.account-group .list-group-item > .avatar {
  width: 60px;
  height: 60px;
  margin: 0 0rem 0 20px;
  -webkit-border-radius: 0px;
  border-radius: 0px;
}
.list-group.account-group .list-group-item > .avatar > img {
  max-width: 60px;
  max-height: 60px;
}
</style>


// WEBPACK FOOTER //
// src/components/AccountType.vue